<template lang="pug">
  div.con
    template
      el-button(class="icon-button ml-20" type="text"
      label='新增自定义权限'
        size="small" icon="el-icon-circle-plus-outline" @click="addHandler" )
    el-dialog(v-dialog-drag title="添加自定义操作权限"
      modal-append-to-body append-to-body
      width="300px"
      top='200px'
      :visible.sync="show",
      :close-on-click-modal="false",
      @close="closeHandler")
      template(#default)
        div.dialog-content
          el-form(:model="form" ref='form' :rules='rules' label-width="80px" size="small" )
            el-form-item(label="操作编码" required prop="actionCode" )
              el-input( v-model="form.actionCode" )
            el-form-item(label="操作名称" required prop="actionName" )
              el-input( v-model="form.actionName" )
      template(#footer)
        div
          .right
            el-button( size="small" @click="closeHandler" ) 取消
            el-button(type="primary" size="small" @click="saveHandler" ) 保存
</template>

<script>
import strategyAuthService from '@/CommonDP/service/strategyAuth-service';

export default {
  name: 'OperateAuthAddDialog',
  props: {
    resourceId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      show: false,
      form: {
        actionCode: '',
        actionName: '',
        resourceId: ''
      },
      rules: {
        actionCode: [
          { required: true, message: '请输入操作编码', trigger: 'blur' }
        ],
        actionName: [
          { required: true, message: '请输入操作名称', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {},
  watch: {},
  created () {},
  methods: {
    addHandler () {
      this.show = true;
      this.$refs.form.clearValidate();
    },
    closeHandler () {
      this.show = false;
      this.showPop();
    },
    showPop () {
      this.popShow = true;
    },
    saveHandler () {
      this.showPop();
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.postData();
        } else {
          console.log('校验未通过');
          return false;
        }
      });
    },

    async postData () {
      const params = this.form;
      params.resourceId = this.resourceId;
      const res = await strategyAuthService.addResourceAction(params);
      this.closeHandler();
      this.$success('添加成功');
      this.initList();
    },
    // 保存操作码
    async initList () {
      const params = {
        resourceId: this.resourceId,
        isQueryDefault: true
      };
      const res = await strategyAuthService.queryActionByResourceId(params);
      this.list = res.data;
      this.$emit('select', this.list || []);
    }
  }
};
</script>

<style scoped lang="scss">
.con{
  display: inline;
  margin-left: 14px;
  .icon-button {
    font-size: 20px;
    vertical-align: middle;
  }
}
</style>
